import { render, staticRenderFns } from "./bigCustomerBoard.vue?vue&type=template&id=0e8da279&scoped=true"
import script from "./bigCustomerBoard.vue?vue&type=script&lang=js"
export * from "./bigCustomerBoard.vue?vue&type=script&lang=js"
import style0 from "./bigCustomerBoard.vue?vue&type=style&index=0&id=0e8da279&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8da279",
  null
  
)

export default component.exports